import { RouteLocationRaw } from "vue-router"

import { Actions, Getters, store } from "@/store"

/**
 * Prevents stale retrospective links from opening a board with the previous store state.
 */
export default async (
  to,
  from,
  next: (arg?: RouteLocationRaw) => void
): Promise<void | boolean> => {
  const sprintId = store.getters[Getters.GET_SESSION_SPRINT_ID]
  const retrospectiveIncludingMetadata = await store.dispatch(
    Actions.GET_RETROSPECTIVE_BY_SPRINT_ID,
    sprintId
  )

  if (!retrospectiveIncludingMetadata?.retrospectiveExists) {
    return next({
      name: "Error",
      query: {
        code: 404
      }
    })
  }

  next()
}
